module.exports = __webpack_public_path__ + "img/阿虎医考山河医学网APP下载二维码.af52d1ff.png";